<div class="fks-tooltip svg-icon__info">
  <svg-icon
    [src]="src"
    [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize }"
    [ngClass]="customClass"
  ></svg-icon>
  <span class="fks-tooltip-data" [ngClass]="'fks-tooltip-data-' + position">
    <ng-content></ng-content>
  </span>
</div>
